/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import classNames from "classnames";

const WorkspacesIcon = ({ className, isActive }) => {
  const fill = isActive ? "#FFFFFF" : "#9A9A9A";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 16 12"
      fill="none"
      className={classNames(className)}
      test-id="G-n8spsr"
    >
      <path
        d="M5.70312 3H10.2969V1.59375H5.70312V3ZM1.39062 11.8125C1.19687 11.8125 1.03125 11.7438 0.89375 11.6063C0.75625 11.4688 0.6875 11.3031 0.6875 11.1094V8.10938H3.5V8.25C3.5 8.44375 3.56875 8.60938 3.70625 8.74688C3.84375 8.88438 4.00938 8.95312 4.20312 8.95312C4.39687 8.95312 4.5625 8.88438 4.7 8.74688C4.8375 8.60938 4.90625 8.44375 4.90625 8.25V8.10938H11.0938V8.25C11.0938 8.44375 11.1625 8.60938 11.3 8.74688C11.4375 8.88438 11.6031 8.95312 11.7969 8.95312C11.9906 8.95312 12.1562 8.88438 12.2938 8.74688C12.4313 8.60938 12.5 8.44375 12.5 8.25V8.10938H15.3125V11.1094C15.3125 11.3031 15.2438 11.4688 15.1063 11.6063C14.9688 11.7438 14.8031 11.8125 14.6094 11.8125H1.39062ZM0.6875 7.40625V4.40625C0.6875 4.01953 0.825194 3.68847 1.10058 3.41308C1.37597 3.13769 1.70703 3 2.09375 3H4.29688V1.59292C4.29688 1.20597 4.43457 0.875 4.70996 0.6C4.98534 0.325 5.3164 0.1875 5.70312 0.1875H10.2969C10.6836 0.1875 11.0147 0.325194 11.29 0.600581C11.5654 0.875969 11.7031 1.20703 11.7031 1.59375V3H13.9062C14.293 3 14.624 3.13769 14.8994 3.41308C15.1748 3.68847 15.3125 4.01953 15.3125 4.40625V7.40625H12.5V6.5625C12.5 6.36875 12.4313 6.20312 12.2938 6.06563C12.1562 5.92812 11.9906 5.85938 11.7969 5.85938C11.6031 5.85938 11.4375 5.92812 11.3 6.06563C11.1625 6.20312 11.0938 6.36875 11.0938 6.5625V7.40625H4.90625V6.5625C4.90625 6.36875 4.8375 6.20312 4.7 6.06563C4.5625 5.92812 4.39687 5.85938 4.20312 5.85938C4.00938 5.85938 3.84375 5.92812 3.70625 6.06563C3.56875 6.20312 3.5 6.36875 3.5 6.5625V7.40625H0.6875Z"
        fill={fill}
        test-id="u21a6h-u"
      />
    </svg>
  );
};

export default WorkspacesIcon;
